import React, { useCallback } from 'react'

import {
  ImageContainer,
  ImageOverlayContainer,
} from './Common'
import DatesVariant from './Common/DatesVariant'

import HeightFillingImage from 'components/Common/HeightFillingImage'
import ProductTypeLabel from 'LuxKit/Label/ProductTypeLabel'
import offerPageURL from 'lib/offer/offerPageURL'
import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import { useTripId } from 'tripPlanner/contexts/TripContext'
import useImmersiveModeHandlers from 'tripPlanner/hooks/useImmersiveModeHandlers'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { TourItem } from 'tripPlanner/types/tripItem'
import { tripItemSelectionId } from 'tripPlanner/utils/itemSelection'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'

interface Props {
  item: TourItem
  offer: App.Tours.TourV2Offer | App.Offer
}

function LuxTour({ item, offer }: Props) {
  const {
    startPlace,
    isBooked,
    name,
    type,
    startDate,
    endDate,
    startDay,
    endDay,
  } = item

  const openModal = useOpenModal()
  const { setImmersiveMode } = useImmersiveModeHandlers()
  const tripId = useTripId()

  const offerUrl = offerPageURL(offer)

  const canEdit = useCanEditTrip()

  const handleClick = useCallback(() => {
    if (isBooked) {
      openModal(TripItemSummary, { item })
    }
    if (canEdit) {
      setImmersiveMode({ tripId, sectionId: tripItemSelectionId(item.id) })
    }
  }, [canEdit, isBooked, item, openModal, setImmersiveMode, tripId])

  return (
    <>
      {offer?.image?.id && (
        <ImageContainer>
          {offer.image.id && <HeightFillingImage id={offer.image.id} />}
          <ImageOverlayContainer>
            <ProductTypeLabel productType={offer.productType} />
          </ImageOverlayContainer>
        </ImageContainer>
      )}
      <DatesVariant
        region={startPlace.region}
        name={name}
        startDate={startDate}
        endDate={endDate}
        type={type}
        isBooked={isBooked}
        onClick={handleClick}
        to={isBooked ? undefined : offerUrl}
        linksToOffer={!isBooked}
        canEdit={canEdit && !isBooked}
        startDay={startDay}
        endDay={endDay}
      />
    </>
  )
}

export default LuxTour
